<div class="container">
  <h1 *ngIf="loading" class="lblLoading">Loading...</h1>
  <h1
    *ngIf="mediaInfo && mediaInfo.segments && mediaInfo.segments.length === 0"
    class="lblNoSegmentsFound"
  >
    No segments found for the media item.
  </h1>
  <div *ngIf="mediaInfo && mediaInfo.segments && mediaInfo.segments.length > 0">
    <h1>
      Choose segment for media item {{ mediaInfo.id }} - {{ mediaInfo.name }}:
    </h1>
    <evrideo-media-segments
      *ngIf="mediaSegmentsViewModel"
      [vm]="mediaSegmentsViewModel"
    ></evrideo-media-segments>
  </div>
</div>
